const l = "_link_1abbc_1", n = {
  link: l
};
export {
  n as default,
  l as link
};
//# sourceMappingURL=Link.module.css.js.map
